var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('viewer',{attrs:{"images":[_vm.image.url],"options":_vm.options},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_c('img',{attrs:{"src":_vm.image.url}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }